// BestSeller
import BestSellerBanner from "@/assets/icons/BestSeller.png";
import BestSellerBannerZHCN from "@/assets/icons/BestSeller_ZHCN.png";
// Almost sold out Icon
import AlmostSoldout from "@/assets/icons/AlmostSoldout.svg";
import AlmostSoldoutZHCN from "@/assets/icons/almostSoldOut_zh_cn.svg";
import AlmostSoldoutZHTW from "@/assets/icons/almostSoldOut_zh_tw.svg";
import AlmostSoldoutDEDE from "@/assets/icons/almostSoldOut_de_de.svg";
import AlmostSoldoutFRFR from "@/assets/icons/almostSoldOut_fr_fr.svg";
import AlmostSoldoutNLNL from "@/assets/icons/almostSoldOut_nl_nl.svg";
// Invite Friend
import InviteCoupon from "@/assets/icons/inviteCoupon.svg";
import InviteCouponZHCN from "@/assets/icons/inviteCoupon_ZHCN.svg";
// Refer More
import PersonalCenterReferMore from "@/assets/icons/PersonalCenterReferMore.svg";
import PersonalCenterReferMore_ZHCN from "@/assets/icons/PersonalCenterReferMore_ZHCN.svg";
import { getI18nLang } from "./settings";

const I18nImageConfig: any = {
  // 英文
  en_GB: {
    bestSeller: BestSellerBanner,
    soldout: AlmostSoldout,
    inviteCoupon: InviteCoupon,
    personalActivityDiagram: PersonalCenterReferMore,
  },
  // 中文
  zh_CN: {
    soldout: AlmostSoldoutZHCN,
    bestSeller: BestSellerBannerZHCN,
    inviteCoupon: InviteCouponZHCN,
    personalActivityDiagram: PersonalCenterReferMore_ZHCN,
  },
  // 繁体中文
  zh_TW: {
    soldout: AlmostSoldoutZHTW,
    bestSeller: BestSellerBanner,
    inviteCoupon: InviteCoupon,
    personalActivityDiagram: PersonalCenterReferMore,
  },
  // 荷兰语
  nl_NL: {
    soldout: AlmostSoldoutNLNL,
    bestSeller: BestSellerBanner,
    inviteCoupon: InviteCoupon,
    personalActivityDiagram: PersonalCenterReferMore,
  },
  // 德语
  de_DE: {
    soldout: AlmostSoldoutDEDE,
    bestSeller: BestSellerBanner,
    inviteCoupon: InviteCoupon,
    personalActivityDiagram: PersonalCenterReferMore,
  },
  // 法语
  fr_FR: {
    soldout: AlmostSoldoutFRFR,
    bestSeller: BestSellerBanner,
    inviteCoupon: InviteCoupon,
    personalActivityDiagram: PersonalCenterReferMore,
  },
};

export const i18nImage = () => {
  const langCookie = getI18nLang();
  return I18nImageConfig[langCookie] || I18nImageConfig["en_GB"];
};
